import { render, staticRenderFns } from "./todaysDeliveryReport.vue?vue&type=template&id=70ed70f2&"
import script from "./todaysDeliveryReport.vue?vue&type=script&lang=js&"
export * from "./todaysDeliveryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports